export default "__VITE_ASSET__f4130983__"